import React, { useEffect, useState } from "react";
import { Button, Container, ListGroup, Nav } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import logger from "../../../../../utils/logger";
import { getRemedy, loadRemedy } from "../../../../controller/reducer/remedy";
import TagDisplay from "../../common/tags";
import RemedyEditModal from "./edit";

const RemedyItem = ({ match }) => {
  const [show, setShow] = useState(false);
  const dispatch = useDispatch();
  const remedy = useSelector(getRemedy);
  logger()(remedy);

  useEffect(() => {
    dispatch(loadRemedy(match.params.id));
  }, [dispatch, match.params.id]);

  return (
    <Container className="p-4">
      <p className=" h3 font-weight-normal mb-2">Description</p>
      <p className=" h4 font-weight-light mb-4">
        {remedy.title ? remedy.title : "Loading..."}
      </p>
      <p className="h3 font-weight-normal mb-2">Tags</p>
      {remedy.tags && <TagDisplay tags={remedy.tags} />}
      <p className="h3 font-weight-normal mb-2">Links</p>
      <ListGroup className="mb-4">
        {remedy.links &&
          remedy.links.map((link, id) => (
            <ListGroup.Item key={id} >
              <Nav.Link
                className="text-truncate"
                target="_blank"
                href={link}
              >
                {link}
              </Nav.Link>
            </ListGroup.Item>
          ))}
      </ListGroup>
      <Button variant="primary" onClick={() => setShow(true)} block>
        Suggest Changes
      </Button>
      {show && (
        <RemedyEditModal
          dispatch={dispatch}
          remedy={remedy}
          show={true}
          onClose={() => setShow(false)}
        />
      )}
    </Container>
  );
};

export default RemedyItem;
